import React from 'react';

import { getProjectStorage } from '@neptune/project-domain';
import { useAsyncValue } from '@neptune/shared/common-util';

export const useGetProjectStorage = (projectIdentifier: string) => {
  const getProjectStorageHandler = React.useCallback(
    async () => getProjectStorage(projectIdentifier),
    [projectIdentifier],
  );

  return useAsyncValue({ resolver: getProjectStorageHandler });
};

export const useHitProjectStorageLimit = (projectIdentifier: string) => {
  const getReachedProjectStorageLimitHandler = React.useCallback(async () => {
    const { storageLimit, storageUsage } = await getProjectStorage(projectIdentifier);

    if (storageLimit === undefined) {
      return false;
    }

    return storageUsage >= storageLimit;
  }, [projectIdentifier]);

  return useAsyncValue({ resolver: getReachedProjectStorageLimitHandler });
};
